import RadioSelector from './index.vue'

RadioSelector.install = Vue => {
  Vue.component(RadioSelector.name, RadioSelector)
}

export {RadioSelector}



// WEBPACK FOOTER //
// ./src/components/radio-selector/index.js